module.exports = __webpack_public_path__ + "static/media/hand-peace.a65fd2fb.svg";